<template>
  <div class="bg-white p-4 radius">
    <QuestionSetAnswering :goBack="goBack"></QuestionSetAnswering>
  </div>
</template>

<script>
import QuestionSetAnswering from "./question-set-answering.vue";
export default {
  components: { QuestionSetAnswering },
  methods: {
    goBack() {
      this.$router.push(`/`);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./question-set";
</style>
